import React from 'react';
import CountryMap from './CountryMap';
import {Card, CardBody, CardHeader} from 'reactstrap';


// @setupAccess([Role.superAdmin])
class Country extends React.Component {
  render() {
    return (
      <div>
        <Card>
          <CardHeader>Patients Per Country</CardHeader>
          <CardBody>
            <CountryMap title="Documentation coverage of patients per country"/>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default Country;


// WEBPACK FOOTER //
// ./src/views/Statistics/CoverageMap/CoverageMap.js